import { API_SET_CONFIGURATION } from "../actions";
import { getTenantNameFromHost } from "../tenant";

// check .env file (and .env.* files) for environment variables
export const defaultState = {
  faceQualityHostname: process.env.REACT_APP_DOMAIN_FACE_QUALITY,
  documentQualityHostname: process.env.REACT_APP_DOMAIN_DOCUMENT_QUALITY,
  sampleAppHostname: process.env.REACT_APP_DOMAIN_MIDDLEWARE,
  livenessPolicyName: process.env.REACT_APP_LIVENESS_POLICY_NAME,
  tenant: process.env.REACT_APP_TENANT || getTenantNameFromHost(),
  gdprServiceHostname: process.env.REACT_APP_GDPR_SERVICE_HOSTNAME,
  extraConfig: {
    featureFlags: {
      showApplicationResults: true
    }
  }
}

export function configuration(state = defaultState, action) {
  switch (action.type) {
    case API_SET_CONFIGURATION:
      return {
        ...state,
        ...action.payload,
        extraConfig: {
          ...state.extraConfig,
          ...action.payload.extraConfig,
          featureFlags: {
            ...state.extraConfig.featureFlags,
            ...((action.payload.extraConfig &&
              action.payload.extraConfig.featureFlags) || 
              {})
          }
        }
      }
    default:
      return state;
  }
}
